import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const gateListTodo = createAsyncThunk('gateList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'gate',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },
        })

        return res

    } catch (error) {
        return error?.response
    }
});

const gateListSlice = createSlice({
    name: 'gateList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(gateListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = []
            }
        });
        builder.addCase(gateListTodo.rejected, (state, action) => {
        })
    }
});

export default gateListSlice.reducer;


